<template lang="pug">
  div.auth.register-set-password
    div.modal.login
      div.modal.login-inner

      transition(name="fade")
       div(:style="{'z-index': 9999}").smallModal.showPasswordRecovery.open
        div.fixed-overlay.fixed-overlay__modal
          div.modal
            div.modal_container
              div.header
                h1.title {{$translate('Установка пароля')}}
              div.body-wrapper
                e-form(:formValidator="formValidator")
                  div.body
                    div.col
                      e-form-subtitle(text="Установите пароль для входа в систему")
                      e-form-group(
                      label="Пароль"
                      :name="PASSWORD.PASS_NEW"
                      inputType="password"
                          :model="fields"
                      tabView="tab1"
                        :required="true"
                      )

                      e-form-group(
                      :name="PASSWORD.PASS_REPEAT"
                      inputType="password"
                      label="Повтор пароля"
                        :model="fields"
                      tabView="tab1"
                        :required="true"
                      )

              div.footer
                div.actions-filter-panel.actions-filter-panel--right
                  div
                    button(
                    type="button"
                    @click="sendForm()"
                    ).actions-filter-panel__button.standart {{$translate('Сохранить')}}
</template>

<script>
  import validationRules from '../../mixins/validation-rules.js'
  import formBaseMixin from '../../components/form/form-base-mixin.js'
  import {account} from '../../api/api-endpoints'

  const PASSWORD = {
    PASS_NEW: 'password',
    PASS_REPEAT: 'repeat_password'
  }

  export default {
    mixins: [validationRules, formBaseMixin],
    title: 'Установка пароля',
    data () {
      return {
        tabView: 'tab1',
        fields: {
          password_reset_token: '',
          [PASSWORD.PASS_NEW]: '',
          [PASSWORD.PASS_REPEAT]: ''
        }
      }
    },
    computed: {
      PASSWORD () {
        return PASSWORD
      }
    },
    methods: {
      afterSave: async function (response) {
        this.$store.commit('userSetAuthData', response.data)
        return Promise.resolve(1)
      },
      onSuccess (response, afterSaveResponse) {
        this.showOnSuccess('Пароль успешно установлен')
        this.unFreezeFrom()
        this.$router.push({path: '/'})
      },
      update () {
        this.fields.password_reset_token = this.$route.query.password_reset_token
      },
      getUpdateOrCreateUrl () {
        return account.password()
      },
      additionalValidate: async function (hasError = false, errors = {}) {
        let manualErrors = {}
        this.minLen([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors)
        this.checkRegExp([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors, '[A-Z]', 'Должна быть хотя бы одна заглавная буква. ')
        this.checkRegExp([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors, '[0-9]', 'Должна быть хотя бы одна цифра. ')
        this.checkRegExp([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors, '^([\x03-\x7E]{1,})$', 'Допустимые символы - латинские буквы, цифры, спец.символы. ')

        if (Object.keys(manualErrors).length === 0) {
          this.compare([this.PASSWORD.PASS_NEW, this.PASSWORD.PASS_REPEAT], manualErrors)
        }

        if (Object.keys(manualErrors).length > 0) {
          this.formValidator.handleServerErrors({data: {errors: manualErrors}}, this)
          return Promise.reject(1)
        }
        return Promise.resolve(1)
      },
      getItemEndpoint () {
        return null
      }
    }
  }
</script>
